import { createRequiredContext } from 'src/context/createRequiredContext';

import { useAddCredentialSlice } from './addCredentialSlice';

const [useAddCredential, AddCredentialProvider] = createRequiredContext<ReturnType<typeof useAddCredentialSlice>>();

const AddCredentialContextProvider = ({ children }: React.PropsWithChildren) => {
  const slice = useAddCredentialSlice();

  const values = {
    ...slice,
  };

  return <AddCredentialProvider value={values}>{children}</AddCredentialProvider>;
};

export { useAddCredential, AddCredentialContextProvider };
